import { useState, useEffect } from 'react'
import { coinGeckoService } from '../services/coingecko'
import { transformCoinGeckoCrypto } from '../services/coingeckoTransformer'
import { Cryptocurrency } from '../types'
import { cryptocurrencies as mockData } from '../data/mockData'

export function useCryptoData(limit: number = 100) {
  const [data, setData] = useState<Cryptocurrency[]>(mockData.slice(0, limit))
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)
  const [lastUpdated, setLastUpdated] = useState<Date>(new Date())

  const fetchData = async () => {
    try {
      setLoading(true)
      setError(null)

      console.log('[CryptoData] Fetching from CoinGecko...')
      const coinGeckoData = await coinGeckoService.getTopCryptocurrencies(limit)

      if (Array.isArray(coinGeckoData)) {
        const transformed = coinGeckoData.map((coin, index) =>
          transformCoinGeckoCrypto(coin, index + 1),
        )
        console.log(
          '[CryptoData] Successfully fetched',
          transformed.length,
          'cryptocurrencies',
        )
        setData(transformed)
        setLastUpdated(new Date())
      }
    } catch (err) {
      console.error('Error fetching crypto data:', err)
      setError(err instanceof Error ? err.message : 'Failed to fetch data')
      // Keep using mock data on error
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchData()

    // Auto-refresh every 60 seconds
    const interval = setInterval(fetchData, 60000)

    return () => clearInterval(interval)
  }, [limit])

  return { data, loading, error, lastUpdated, refresh: fetchData }
}
